/* Only badge visibility is updated here; cart and price handlers are untouched. */
(function () {
  'use strict';
  if (window.__snProductBadgesV1) return;
  window.__snProductBadgesV1 = true;

  function syncBadges(root, variantId) {
    if (!root) return;
    var id = String(variantId || root.dataset.snSelectedVariant || '');
    root.dataset.snSelectedVariant = id;
    root.querySelectorAll('[data-sn-badge-variant]').forEach(function (badge) {
      badge.hidden = badge.dataset.snBadgeVariant !== id;
    });
    root.hidden = !root.querySelector('.sn-product-badge:not([hidden])');
  }

  function syncRoot(root) {
    var card = root.closest('[data-sn-card]');
    if (card) {
      var select = card.querySelector('[data-sn-select]');
      syncBadges(root, select ? select.value : card.dataset.defaultVariantId);
      return;
    }
    var section = root.closest('[id^="shopify-section-"]');
    var active = section && section.querySelector('.sn-variant-btn.sn-active');
    syncBadges(root, active ? active.dataset.id : root.dataset.snSelectedVariant);
  }

  function scan(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-sn-product-badges]')) syncRoot(scope);
    scope.querySelectorAll('[data-sn-product-badges]').forEach(syncRoot);
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-sn-select]')) return;
    var card = select.closest('[data-sn-card]');
    if (card) card.querySelectorAll('[data-sn-product-badges]').forEach(function (root) {
      syncBadges(root, select.value);
    });
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.sn-variant-btn');
    if (!button) return;
    var section = button.closest('[id^="shopify-section-"]');
    if (!section) return;
    var active = section.querySelector('.sn-variant-btn.sn-active');
    section.querySelectorAll('.sn-product-badges--pdp').forEach(function (root) {
      syncBadges(root, active ? active.dataset.id : root.dataset.snSelectedVariant);
    });
  });

  function init() {
    scan(document);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

